module.exports = __webpack_public_path__ + "media/images/flags/at-9acfac7bcd3f2c3c4c65a770c91b373b.svg";